module.exports = __webpack_public_path__ + "media/images/photos/spain-f1aeb006cebd4dbbf67baf4a5d1c907c.jpg";